<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12 special-title">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section  form-section">
              <p class="form-title text-center" style="font-size: 25px;">                
                  STATEMENT OF INSURED                
                <br>
                THIS FORM MUST BE COMPLETED IN DETAIL FOR EACH NEW RISK PLACED
                AND FOR RENEWAL OF PREVIOUSLY PLACED RISKS. A COPY OF THIS
                STATEMENT MUST BE PROVIDED TO THE INSURED AND MAINTAINED IN
                AGENT’S FILES.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <p class="notice-form-date col-md-2" style="text-align: left">INSURED:</p>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="orep-text-input notice-input"
                    v-model="quote.fullLegalNameOfApplicant"
                    disabled
                  >
                </div>
              </div>
              <div class="row">
                <p class="notice-form-date col-md-2" style="text-align: left">COVERAGE TYPE:</p>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="orep-text-input notice-input"
                    value="Professional Liablity"
                    disabled
                  ></div>
              </div>
              <div class="row">
                <p class="notice-form-date  col-md-2" style="text-align: left">POLICY PERIOD:</p>
              </div>
            </article>

            <article class="input-section form-section">
              <div >
                <p>
                    <strong>
                      Check one of the options below:
                    </strong>

                </p>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                      type="radio"
                      name="ksOption"
                      :value="0"
                      class="orep-radio position-relative"
                      v-model="quote.ksOption"
                      disabled
                    >
                    <span
                      class="radio-span solo-checkbox-span no-top"
                    >EXEMPT COMMERCIAL PURCHASER (defined in K.S.A. 40-246i)</span>
                  </label>
                </div>
                  <p class="mb-3 ar-sl-disclosure">
                      As required by K.S.A. 40-246b, this will certify that I, the undersigned, have requested insurance coverage to be
                      placed on my behalf with a company that is non-admitted or licensed to transact business in the State of Kansas. I
                      understand, that as an exempt commercial purchaser, contrary to K.S.A. 40-246b, a diligent search of the admitted
                      market is not required to place this coverage with a company that is non-admitted or licensed to transact business in
                      this state. I further understand that such insurance may or may not be available from the admitted market that may
                      provide greater protection with more regulatory oversight.</p>
                </div>
            </article>
            <article class="input-section form-section">
              <div >
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                      type="radio"
                      name="ksOption"
                      :value="1"
                      class="orep-radio position-relative"
                      checked="checked"
                      v-model="quote.ksOption"
                      disabled
                    >
                    <span
                      class="radio-span solo-checkbox-span no-top"
                    >ALL OTHER INSUREDS (Other than exempt commercial purchasers)</span>
                  </label>
                </div>

                <p class="mb-3 ar-sl-disclosure">                  
                    As required by K.S.A. 40-246b, this will certify that I, the undersigned, have requested insurance coverage to be
                    placed on my behalf with a company that is non-admitted or licensed to transact business in the State of Kansas. I
                    understand that in accordance with K.S.A. 40-246b, that mere rate differential shall not be grounds for placing a
                    particular risk with a non-admitted company when an admitted company would accept such risk at a different rate.</p>
              </div>
            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure" >
                  1. The insurance coverage requested will be provided by an insurance company that is non-admitted or licensed to
                    transact business in the State of Kansas, and whose name appears on the list of non-admitted companies
                    maintained by the Commissioner of Insurance. The non-admitted insurers’ financial condition, policy forms,
                    rates and trade practices are not subject to review or the jurisdiction of the Commissioner of Insurance.</p>
                <p class="mb-3 ar-sl-disclosure" >
                    2. There shall be no liability on the part of, and no cause of action of any nature shall arise against the
                    Commissioner of Insurance, employees thereof, or the State of Kansas because the name of an insurance
                    company appears or does not appear on the list of non-admitted companies maintained by the Commissioner of
                    Insurance.</p>
                <p class="mb-3 ar-sl-disclosure">
                    3. The policies or contracts of insurance issued by a non-admitted insurance company do not come under the
                    protection afforded by the Kansas Insurance Guaranty Association Act (K.S.A. 40-2901, et seq.).</p>
                <p class="mb-3 ar-sl-disclosure">
                    4. If the insurance company affording coverage is subsequently determined to be insolvent, the licensed excess
                    lines agent placing such business with a company nonadmitted to transact business in Kansas is, by giving you
                    the information contained herein, relieved of any responsibility to the insured as it relates to such solvency.</p>
                <p class="mb-3 ar-sl-disclosure">
                    5. Each licensed agent shall collect and pay to the commissioner a tax of 6% on the total gross premiums charged,
                    less any return premiums, for surplus lines insurance transacted by the licensee pursuant to the license for insureds
                    whose home state is this state. (K.S.A. 40-246c).</p>
              </div>
            </article>
            <article class="form-heading form-section review-sign input-section">
              <div class="row mb-4">
                <div class="col-md-6">
                  <label class="orep-label m-0">
                    Insured
                  </label>
                </div>
                <div class="col-md-6">
                  <label class="orep-label m-0">
                    Agent
                  </label>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6 form-inline">
                  <label for class="orep-label mb-0 mr-2">
                    Signature:
                  </label>
                  <input
                    type="text"
                    name="clientSignature"
                    class="orep-text-input form-control"
                    v-validate="'required'"
                    v-model="quote.slDisclosureSignature"
                    placeholder="Type Your Name to Sign"
                    @input="validateBeforeSubmit()"
                  >
                  <span
                    v-show="errors.has('slDisclosureSignature')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                </div>
                <div class="col-md-6 form-inline">
                  <label for class="orep-label mb-0 mr-2">
                    Signature:
                  </label>
                  <img src="../../../public/assets/images/sign.png" alt="Sign" style="max-height: 40px;">
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6 form-inline">
                  <label for class="orep-label mb-0 mr-2">
                    Date:
                  </label>
                  <h5 class="m-0">{{formattedCurrentDate()}}</h5>
                </div>
                <div class="col-md-6 form-inline">
                  <label for class="orep-label mb-0 mr-2">
                    Name:
                  </label>
                  <h5 class="m-0">Isaac Peck</h5>
                </div>
              </div>
              <div class="row mb-5 justify-content-end">
                <div class="col-md-offset-6 col-md-6 form-inline">
                  <label for class="orep-label mb-0 mr-2">
                    Title:
                  </label>
                  <h5 class="m-0">President</h5>
                </div>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="ksCoverage"
                    value
                    class="orep-radio position-relative"
                    v-model="quote.ksCoverage"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >I was unavailable or otherwise unable to sign this statement prior to the effective date of coverage</span>
                </label>
              </div>

              <div style="padding-top: 50px;padding-bottom: 24px">
                <p>
                  SOI (11/17)
                </p>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'property-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "property-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

